import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../../../components/Breadcrumbs/Breadcrumbs';
import { t } from 'i18next';
import useStore from '../../../../store/useStore';
import { useAllSettings } from '../../../../graphql/settings/storeSettings/AllSettings';
import { useMutation } from '@apollo/client';
import { UpdateNavBarStore } from '../../../../graphql';
import SuccessAlert from '../../../../components/Alerts/SuccessAlert';
import FailAlert from '../../../../components/Alerts/FailAlert';

const Navbar = () => {

  const storeData = useStore((state: any) => state.userData.store);

  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [content, setContent] = useState("");
  const [navbarBgColor, setNavbarBgColor] = useState("#00C6C0")

  const [AllSettings, { data: dataAllSettings }] = useAllSettings()

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    storeData &&
      (async () => {
        await AllSettings({
          variables: { idStore: storeData.id }
        })

        setInitialLoading(false)
      })()
  }, [storeData]);

  useEffect(() => {
    if (dataAllSettings?.allSettings) {
      dataAllSettings?.allSettings.navBar.text !== null && setContent(dataAllSettings?.allSettings.navBar.text)
      dataAllSettings?.allSettings.navBar.background !== null && setNavbarBgColor(dataAllSettings?.allSettings.navBar.background)
    }
  }, [dataAllSettings])

  const [updateNavBarStore, { error }] = useMutation(UpdateNavBarStore);

  const updateNavbar = async () => {
    await updateNavBarStore({
      variables: {
        idStore: storeData.id,
        content: {
          background: navbarBgColor,
          text: content
        }
      }
    })

    if (!error) {
      setSuccessMsg(t('updateSuccess'));
      setSuccess(true);
    }
  }

  return (
    <section className='my-4 mx-3 md:mx-7'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='flex flex-col-reverse md:flex-row md:justify-between md:items-center'>
        <div>
          <h3 className='text-2xl font-semibold'>{t('navbar')}</h3>
        </div>
        <div>
          <Breadcrumbs />
        </div>
      </div>

      <div className='relative p-2 mt-3 bg-white rounded-md'>
        {
          initialLoading &&
          <div className='absolute left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
            <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
          </div>
        }
        <div className='pt-2'>
          <div className="mb-4">
            <div className='flex items-center justify-between'>
              <label htmlFor="content" className="block mb-2 text-sm font-medium text-gray-900">{t('content')}</label>
              <span className='text-sm'>
                {content.length}/60
              </span>
            </div>
            <input type="text" id="content" value={content} onChange={(e) => setContent(e.target.value)} maxLength={60} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" />
          </div>
        </div>


        <div className='flex items-center gap-5'>
          <label>{t('backgroundColor')}</label>
          <div>
            <label htmlFor="buttonColor" className="flex justify-center items-center text-sm rounded-lg p-2.5 w-24 text-white" style={{ backgroundColor: navbarBgColor }}>
              {navbarBgColor}
              <input type="color" id='buttonColor' onChange={(e) => setNavbarBgColor(e.target.value)} className="w-0 h-0 overflow-hidden" />
            </label>
          </div>
        </div>

        <div className='mt-5 mb-2'>
          <span>{t('navbarPreview')}</span>

          <div className='mt-1'>
            <div className='flex items-center justify-center px-3 py-2 text-white' style={{ backgroundColor: navbarBgColor }}>
              {content}
            </div>
          </div>
        </div>

        <div className='flex justify-end pt-6'>
          <button onClick={() => updateNavbar()} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
              <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"></path>
            </svg>

            <span className="mx-2">
              {t('save')}
            </span>
          </button>
        </div>
      </div>
    </section>
  )
}

export default Navbar